/* ==========================================================================
   fm-bis-row.js — Produit épuisé : « Épuisé » + Klaviyo sur une ligne (For.me)
   --------------------------------------------------------------------------
   À CHARGER sur la fiche produit, à côté de product.js :
     <script src="{{ 'fm-bis-row.js' | asset_url }}" defer></script>

   CE QU'IL FAIT — ET CE QU'IL NE FAIT PLUS
   Quand le bouton d'ajout est désactivé (variante épuisée) :
     1. il DÉPLACE le conteneur Klaviyo dans la ligne d'achat ;
     2. il donne à leur bouton la classe `fm-bis-button` ;
     3. il remplace son contenu par une cloche + un libellé court, qui tient
        sur une ligne dans une demi-largeur.

   LA MISE EN PAGE N'EST PLUS DE SON RESSORT. Elle était pilotée par une
   classe .fm-epuise posée ici, et le temps que le script s'exécute la page
   montrait un instant la disposition « en stock », sélecteur de quantité
   compris. C'est maintenant product.css §12 qui lit l'état directement, avec
   `:has(.add-to-cart-button:is(:disabled, …))` : appliqué au premier calcul
   de style, donc aucun clignotement. Ne remets pas de classe ici en pensant
   bien faire, ce serait revenir en arrière.

   POURQUOI DÉPLACER LE CONTENEUR PLUTÔT QUE LE SUPERPOSER
   Leur bouton est injecté dans son propre conteneur, ailleurs dans la page :
   il n'est pas frère du bouton « Épuisé ». Le poser en absolu sur la moitié
   droite aurait voulu dire gérer à la main sa largeur, sa hauteur et son
   alignement à chaque largeur d'écran — et recommencer au moindre changement
   de la ligne. En le déplaçant DANS la ligne, c'est le même flex que pour la
   quantité et le bouton qui s'en occupe, gouttière comprise.

   SON HABILLAGE : NI ZÈBRE, NI BOUTON DU THÈME
   On lui pose une classe à nous, `fm-bis-button`, et surtout PAS
   `add-to-cart-button` : celle-là aurait tiré tout l'imprimé zèbre avec elle.
   Le style est dans product.css §12 — même biseau que « Épuisé » (la variable
   --fm-soldout-shadow, partagée), fond transparent, texte dans le marron de
   la marque, et une petite cloche devant le libellé.
   ========================================================================== */
(function () {
  'use strict';

  var main = document.getElementById('MainContent');
  if (!main || (main.getAttribute('data-template') || '').indexOf('product') !== 0) return;

  /* Le libellé d'origine — « Me prévenir du retour en stock » — passe à la
     ligne dans une demi-largeur. Celui-ci tient sur une ligne jusque sur les
     écrans les plus étroits, et garde le tutoiement du site. */
  var LIBELLE = 'PRÉVIENS-MOI';

  /* Cloche de notification, dessinée à la main : deux traits, un corps et un
     battant. En `currentColor`, donc elle suit la couleur du texte sans
     qu'on ait à la redéfinir si le marron change. */
  var CLOCHE =
    '<svg class="fm-bis-cloche" viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">' +
      '<path d="M18 9.2a6 6 0 1 0-12 0c0 4.8-2 6.3-2 6.3h16s-2-1.5-2-6.3Z" ' +
        'stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>' +
      '<path d="M10.2 18.6a2.1 2.1 0 0 0 3.6 0" ' +
        'stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
    '</svg>';

  function ligneAchat() {
    return document.querySelector('#MainContent .product-details .product-form-buttons')
        || document.querySelector('#MainContent .product-information .product-form-buttons');
  }

  function boutonAjout(ligne) {
    return ligne ? ligne.querySelector('.add-to-cart-button') : null;
  }

  function conteneurKlaviyo() {
    return document.getElementById('klaviyo-bis-button-container');
  }

  /* Les trois façons dont le thème marque un bouton indisponible. On les teste
     toutes : la variante épuisée pose `disabled`, mais le rendu de section
     après changement de variante peut n'avoir posé que l'attribut ARIA. */
  function estEpuise(btn) {
    if (!btn) return false;
    return btn.disabled === true
        || btn.hasAttribute('disabled')
        || btn.getAttribute('aria-disabled') === 'true';
  }

  function habiller(conteneur) {
    var b = conteneur.querySelector('button');
    if (!b) return;

    if (!b.classList.contains('fm-bis-button')) b.classList.add('fm-bis-button');

    /* On ne réécrit QUE si le contenu n'est pas déjà le nôtre : sinon chaque
       passage provoquerait une mutation, qui relancerait l'observateur, qui
       réécrirait… en boucle. Deux conditions, parce que leur application peut
       re-rendre le libellé seul en laissant la classe, ou l'inverse. */
    var dejaFait = b.querySelector('.fm-bis-cloche') && b.textContent.trim() === LIBELLE;
    if (!dejaFait) {
      b.innerHTML = CLOCHE + '<span class="fm-bis-texte">' + LIBELLE + '</span>';
    }
  }

  function appliquer() {
    var ligne = ligneAchat();
    if (!ligne) return;

    var btn = boutonAjout(ligne);
    if (!btn) return;

    if (!estEpuise(btn)) return;    /* en stock : rien à déplacer */

    var kl = conteneurKlaviyo();
    if (!kl) return;                /* leur script n'a pas encore injecté */

    if (kl.parentElement !== ligne) ligne.appendChild(kl);
    habiller(kl);
  }

  /* Un seul passage par image : l'observateur peut se déclencher en rafale
     pendant un rendu de section, et appliquer() lit des géométries. */
  var enAttente = false;
  function planifier() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () {
      enAttente = false;
      appliquer();
    });
  }

  /* POURQUOI UN OBSERVATEUR *ET* UN GUET
     L'observateur couvre ce qui se passe dans la fiche : changement de
     variante (le thème re-rend la section et remplace le bouton), passage de
     disponible à épuisé. Le guet couvre l'injection de Klaviyo, qui arrive
     quand elle arrive et parfois HORS de la zone observée. 20 s suffisent
     largement ; au-delà, c'est que leur script ne viendra pas. */
  new MutationObserver(planifier).observe(main, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'aria-disabled'],
  });

  (function guetter(restant) {
    appliquer();
    if (restant <= 0) return;
    var kl = conteneurKlaviyo();
    var ligne = ligneAchat();
    /* Déjà en place : plus rien à guetter, l'observateur prend le relais. */
    if (kl && ligne && kl.parentElement === ligne) return;
    window.setTimeout(function () { guetter(restant - 1); }, 300);
  })(66);   /* 66 x 300 ms ≈ 20 s */

  window.addEventListener('pageshow', planifier);
})();